module.exports = __webpack_public_path__ + "static/media/appleSSOIcon.3c5affab.svg";